import { validatePlatformContent } from "utils/newMediaValidation";

/**
 * Validates Instagram post content and media
 * @param {Object} params - The parameters for validation
 * @param {String} params.caption - The post caption
 * @param {String} params.postType - The type of post (post, reel, story)
 * @param {Array} params.mediaList - Media files for the post
 * @param {Array} params.hashtags - Hashtags in the caption
 * @param {Array} params.tag_users - Users tagged in the post
 * @param {Array} params.tag_collaborators - Collaborators tagged in the post
 * @param {Number} params.monthlyPosts - Available monthly posts
 * @returns {Boolean} - Whether the post has validation errors
 */
const validateInstagram = ({
  caption,
  postType,
  mediaList,
  hashtags,
  tag_users,
  tag_collaborators,
  monthlyPosts,
}) => {
  const errorList = [];

  const { platformErrors, mediaList: mediaListValidated } =
    validatePlatformContent({
      mediaListRaw: mediaList,
      platform: "instagram",
      postType,
      caption,
    });

  errorList.push(
    platformErrors.length > 0 ||
      mediaListValidated.some((media) => media.errors.length > 0)
  );
  errorList.push(hashtags && hashtags.length > 30);
  errorList.push(
    postType !== "story" &&
      tag_users?.reduce((sum, obj) => sum + obj?.tags?.length, 0) > 20
  );
  errorList.push(
    postType !== "story" && tag_collaborators?.length > 3
  );
  errorList.push(monthlyPosts < 1);

  return errorList.includes(true);
};

export default validateInstagram;
